// Legend.js
import React from 'react';
import './legend.css';

const Legend = ({ styleDefinition }) => {
  console.log("Legend component rendered", styleDefinition);

  if (!styleDefinition || styleDefinition.length === 0) {
    return <p>No legend available.</p>;
  }

  return (
    <div className="legend">
      <h3>Legend</h3>
      {styleDefinition.map((item, index) => {

        return (
          <div key={index} className="legend-item">
            <span
              className="legend-color"
              style={{ backgroundColor: item.color }}
            ></span>
            <span className="legend-label">
              {item.label ? item.label : `${item.min} - ${item.legend_max !== undefined ? item.legend_max : item.max}`}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default Legend;